import { REGIONS } from 'shared/constants';

const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'ENUM',
    key: 'region',
    label: 'Region',
    options: REGIONS
  }
];

export default {
  id: 'EventList',
  name: 'Event Landing',
  creator: 'Thomas Davison',
  updatedBy: 'Bobby Sun',
  createdAt: 1566510712000,
  updatedAt: 1566510712000,
  slots,
  templateSettings,
  defaultProps
};
